export const HEADERS = {
  // HMAC Headers
  X_API_KEY: "X-Api-Key",
  X_SIGNATURE: "X-Signature",
  X_TIMESTAMP: "X-Timestamp",
  X_USER_ID: "X-User-Id",
  X_REQUEST_ID: "X-Request-Id",
  X_SOURCE: "X-Source",
  X_SDK_VERSION: "X-Sdk-Version",
  // JWT Headers
  X_AUTHENTICATION: "X-Authentication",
  // Common Headers
  X_PLATFORM: "X-Platform",
  X_DEVICE_ID: "X-Device-Id"
};
